<template>
  <div class="personal-series-wrapper" ref="wrapperRef">
    <div class="personal-series-container" ref="contentRef">
      <div class="personal-series">
      <!-- <el-carousel height="150px">
        <el-carousel-item v-for="item in 4" :key="item">
          <h3 class="small justify-center" text="2xl">{{ item }}</h3>
        </el-carousel-item>
      </el-carousel> -->


      <HDFHeader03 />
      
      <div class="score-content-box">
        <div class="content">

          <div class="top">
            <p class="top-text">{{ videoGroup.title }}</p>
            <div class="img-box">
              <img src="@/assets/images/zhima/zhima-content-top-img.jpg" alt="">
            </div>
          </div>

          <div class="intro">
            <h2 class="title">课程介绍</h2>
            <p class="intro-text">
              {{ videoGroup.intro ? videoGroup.intro : '暂无课程相关介绍' }}
            </p>
          </div>

          <div class="score-box">
            <h2 class="title">课程目录</h2>
            <h3 v-if="!videoInfoList || videoInfoList.length == 0" style="color: #888;">暂无相关课程</h3>
            <el-row v-for="(item, index) in videoInfoList" :key="index">
              <el-col :span="22" @click="playVideo(item.id)">
                <div class="score-list grid-content bg" >
                  <span>{{ item.name }}</span>
                  <span class="video-time-text">{{ Math.floor(item.timeSize/60) + '分' + item.timeSize % 60 + '秒' }} <span class="pay-btn" v-if="item.free != 'yes' && item.price > 0" @click.stop="showPayDialog(item.id, item.name)">购买（{{item.price}}￥）</span></span>
                </div>
              </el-col>
            </el-row>
          </div>

        </div>
      </div>


    </div>
    <div>
      <!-- <HDFFooter /> -->
      <!-- <HDFCopyright /> -->
      <div class="home-footer"></div>
    </div>

    <!-- 视频播放器弹窗 -->
    <el-dialog
        v-model="dialogVisible"
        title="视频播放器"
        width="770"
        :before-close="handleClose"
        append-to-body
      >
        <video
          v-if="videoUrl"
          :src="videoUrl"
          controls
          autoplay
          style="width: 100%; height: auto;"
          @contextmenu.prevent
          controlsList="nodownload"
        ></video>
        <p v-else>请提供视频链接</p>
        <template #footer>
          <el-button @click="handleClose">关闭</el-button>
        </template>
      </el-dialog>


      <PaymentModal ref="paymentModelRef"/>
    </div>
  </div>

</template>
<script setup>
// import HDFCopyright from '@/components/HDFCopyright.vue';
// import HDFFooter from '@/components/HDFFooter.vue';
import HDFHeader03 from '@/components/HDFHeader03.vue';
import { useRoute } from 'vue-router';
import { onMounted, onBeforeUnmount, reactive, ref } from 'vue';

import { getVideoGroupInfo, getVideoSTS, apiCreateOrder } from '@/api/video';
import PaymentModal from '@/components/PaymentModal.vue'

// ===================== 等比例缩放逻辑 =====================
const wrapperRef = ref(null)
const contentRef = ref(null)
const MAX_WIDTH = 1920 // 界面最大宽度
const SCALE_WIDTH = 1920 // 缩放基准宽度

const updateScale = () => {
  if (!wrapperRef.value || !contentRef.value) return
  
  const screenWidth = window.innerWidth
  
  if (screenWidth < SCALE_WIDTH) {
    // 小于1920px时进行等比例缩放
    const scale = screenWidth / SCALE_WIDTH
    
    // 设置容器高度为缩放后的实际高度
    const contentHeight = contentRef.value.scrollHeight
    wrapperRef.value.style.height = `${contentHeight * scale}px`
    
    // 应用缩放
    contentRef.value.style.transform = `scale(${scale})`
    contentRef.value.style.transformOrigin = 'top left'
    contentRef.value.style.margin = '0'
  } else {
    // 大于等于1920px时保持原始大小并居中
    wrapperRef.value.style.height = 'auto'
    contentRef.value.style.transform = 'none'
    contentRef.value.style.margin = '0 auto'
  }
}

const videoGroup = reactive({});
const videoInfoList = ref([])

const route = useRoute();
let id = route.query.id; // 替换为你的参数名

const dialogVisible = ref(false); // 控制弹窗显示
const videoUrl = ref(''); // 视频链接

const paymentModelRef = ref(null);

// 打开弹窗并设置视频链接
const openDialog = (url) => {
  videoUrl.value = url; // 替换为实际视频链接
  dialogVisible.value = true;
};

// 关闭弹窗并清空视频链接
const handleClose = () => {
  dialogVisible.value = false;
  videoUrl.value = ''; // 清空视频链接
};


const initPageData = () => {
  getVideoGroupInfo({id: id}).then(response => {
    const res = response.data;
    if(res.code === 200){
      videoGroup.value = res.data.videoGroup
      videoInfoList.value = res.data.videoInfoList
    }
  })
}

const playVideo = (id) => {
  getVideoSTS({id: id}).then(response => {
    const res = response.data;
    if(res.code === 200){
      openDialog(res.data)
    }
  })
}
const showPayDialog = (videoId, videoName) => {
  apiCreateOrder({videoId}).then(response => { 
    const res = response.data;
    if (res.code === 200) {
      const orderInfo = res.data;
      paymentModelRef.value.showDialog(
        '选择支付方式',
        orderInfo.orderNo,
        orderInfo.price,
        `${videoName}（单视频）`
      )
    }
  })
  
}

onMounted(() => {
  initPageData();
  updateScale()
  window.addEventListener('resize', updateScale)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateScale)
})


// const scores = [
//   {
//     title: '青少年人工智能技术水平测试',
//     intro: '主要用于考察青少年在人工智能关键技术、产品、服务及应用方面的能力水平。整个考试体系包括8个级别，难度逐级提升，为广大青少年的升学、实习、进修等提供人工智能体系能力水平的证明。',
//     dicts: [
//       '1.人工智能基础概念解析',
//       '2.Python编程能力强化',
//       '3.机器学习核心算法精讲',
//       '4.智能系统项目实践',
//       '5.认证考试全真模拟',
//       '6.职业发展路径规划',
//     ]
//   },
//   {
//     title: 'Python编程入门与AI启蒙',
//     intro: '专为零基础学员设计的入门课程，通过图形化工具与趣味游戏开发，系统学习Python语法及编程思维。结合简易AI项目如智能猜数游戏、疫情数据可视化，培养算法设计能力，为后续机器学习、计算机视觉等AI核心领域奠定坚实基础。',
//     dicts: [
//       '1.编程世界初体验',
//       '2.变量与数据类型探秘',
//       '3.条件判断与循环控制',
//       '4.函数模块化编程',
//       '5.趣味AI小项目实践',
//     ]
//   },
//   {
//     title: '机器学习初探——智能决策训练营',
//     intro: '借助Scikit-learn与图形化建模平台，从生活场景切入理解机器学习核心概念。通过房价预测、鸢尾花分类、客户分群等实战项目，掌握数据预处理、模型训练与评估方法，培养用数据驱动决策的思维方式，开启AI算法工程师的第一课。',
//     dicts: [
//       '1.认识机器学习三大范式',
//       '2.线性回归预测实战',
//       '3.决策树分类器构建',
//       '4.K-means聚类实践',
//       '5.模型评估与优化'
//     ]
//   },
//   {
//     title: '计算机视觉魔法课堂',
//     intro: '从图像数字化原理到前沿卷积神经网络，通过OpenCV与PyTorch框架开发实用视觉应用。学员将亲手实现人脸情绪识别、车辆检测、医学影像分割等项目，理解AI如何“看懂”世界，并探讨自动驾驶、智能安防等产业中的技术落地场景。',
//     dicts: [
//       '1.图像数字化原理',
// 			'2.边缘检测与特征提取',
// 			'3.卷积神经网络入门',
// 			'4.实时人脸识别系统',
// 			'5.智能相册分类项目',
//     ]
//   },
//   {
//     title: '自然语言处理工坊',
//     intro: '聚焦中文语境下的NLP技术，从词向量构建到深度学习模型，解析智能客服、舆情监控等真实应用。通过唐诗生成器、微博情感分析、智能问答系统等项目，掌握Transformer架构与预训练模型的使用，体验语言AI从理解到创造的完整链条。',
//     dicts: [
//       '1.中文分词与词向量',
// 			'2.文本情感分析实战',
// 			'3.RNN与LSTM原理',
// 			'4.对话系统设计',
// 			'5.智能写作助手开发',
//     ]
//   },
//   {
//     title: 'AI机器人设计与实践',
//     intro: '融合硬件编程与AI算法，基于ROS机器人操作系统开发智能体。从传感器数据采集到自主导航算法实现，通过迷宫探索、物资搬运、多机协作等挑战任务，掌握SLAM建图、路径规划、多模态交互等关键技术，培养软硬件结合的工程化思维。',
//     dicts: [
//       '1.传感器数据采集',
// 			'2.运动控制系统搭建',
// 			'3.SLAM建图与导航',
// 			'4.多模态交互设计',
// 			'5.智能救援机器人项目',
//     ]
//   },
//   {
//     title: '数据分析与可视化大师课',
//     intro: '以Python生态为核心，通过Pandas数据清洗、Matplotlib/Seaborn可视化、Tableau商业分析等工具链，深度剖析电商用户行为、城市交通流量等真实数据集。培养从数据获取、特征工程到洞察呈现的全流程能力，完成专业级分析报告。',
//     dicts: [
//       '1.数据清洗与预处理',
// 			'2.统计分析方法实践',
// 			'3.动态可视化图表制作',
// 			'4.疫情数据追踪项目',
// 			'5.商业智能分析报告',
//     ]
//   },
//   {
//     title: '深度学习神经网络解密',
//     intro: '从手写数字识别到AI艺术创作，通过TensorFlow/Keras框架揭开深度学习黑箱。重点解析CNN图像处理、RNN时序预测、GAN生成对抗网络原理，完成肺炎X光诊断、股票趋势预测、二次元头像生成等前沿项目，培养模型调优与迁移学习能力。',
//     dicts: [
//       '1.神经元与激活函数',
// 			'2.手写数字识别实战',
// 			'3.生成对抗网络创作',
// 			'4.迁移学习技巧',
// 			'5.自主创新模型设计',
//     ]
//   },
//   {
//     title: 'AI伦理与未来社会',
//     intro: '通过无人驾驶电车难题、AI招聘性别偏见等经典案例，探讨算法公平性、数据隐私、技术失业等社会议题。结合联邦学习、可解释AI等技术解决方案，引导学生建立科技向善的价值观，并通过模拟联合国式辩论赛培养批判性思维与跨学科视野。',
//     dicts: [
//       '1.算法偏见案例分析',
// 			'2.数据隐私保护技术',
// 			'3.人机协作未来图景',
// 			'4.AI可持续发展研讨',
// 			'5.科技伦理辩论赛',
//     ]
//   },
//   {
//     title: '智能硬件创客实验室',
//     intro: '基于树莓派与Arduino开发平台，打造物联网与AI结合的创新项目。从温湿度监测到语音控制家电系统，学习MQTT通信协议、边缘计算等技术，最终完成智慧农场环境调控、垃圾分类机器人等综合实践，打通从代码到物理世界的创新链路。',
//     dicts: [
//       '1.嵌入式系统基础',
// 			'2.环境监测站搭建',
// 			'3.语音控制家电系统',
// 			'4.能源优化管理系统',
// 			'5.智慧农场模拟项目',
//     ]
//   },
//   {
//     title: 'AI游戏开发特训营',
//     intro: '使用Unity引擎与ML-Agents工具包，开发具有自主学习能力的游戏角色。通过马里奥自动闯关、星际争霸智能体对战等项目，掌握行为树设计、强化学习训练、多智能体协同等关键技术，在虚拟世界中构建AI算法的试验场。',
//     dicts: [
//       '1.游戏AI行为树设计',
// 			'2.路径规划算法实现',
// 			'3.强化学习训练NPC',
// 			'4.多智能体协作系统',
// 			'5.智能塔防游戏创作',
//     ]
//   },
//   {
//     title: 'AI创新项目孵化器',
//     intro: '以联合国可持续发展目标为选题方向，指导学生团队完成AI解决方案的全流程开发。从社区垃圾分类优化到偏远地区教育资源共享，经历需求调研、技术选型、原型开发、用户测试等环节，最终产出可落地的创新作品，并完成投融资路演与商业计划书撰写。',
//     dicts: [
//       '1.需求分析与竞品调研',
// 			'2.技术方案可行性评估',
// 			'3.原型开发与迭代',
// 			'4.用户测试与优化',
// 			'5.商业计划书撰写',
//     ]
//   },
// ]

// let score = ref(scores[0])
// const route = useRoute();

// let id = route.query.id; // 替换为你的参数名
// if(id){
//   score = scores[id]
// }
</script>
<style scoped>
.zhima-top-box{
  width: 100%;
}
.zhima-top{
  width: 100%;
  height: 120px;
}

.zhima-top-box .float-img{
  width: 400px;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
}

.score-content-box{
  width: 100%;
  min-height: 1300px;
  background-image: url('@/assets/images/zhima/zhima-score-content-box.jpg');
  background-size: 100% auto;
  display: flex;
  justify-content: center;
}
.score-content-box .content{
  width: 1168px;
  
}
.score-content-box .content .top{
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.score-content-box .content .top-text{
  text-align: left;
  font-size: 50px;
  font-weight: bold;
}
.score-content-box .content .top .img-box{
  width: 200px;
}
.score-content-box .content .top .img-box img{
  width: 100%;
}


.score-content-box .content .intro{
  width: 100%;
  text-align: left;
  margin-top: 40px;
}

.score-content-box .intro .title{
  font-size: 28px;
}
.score-content-box .intro .intro-text{
  color: #969696;
  margin-top: 10px;
}

.score-content-box .score-box{
  text-align: left;
  margin-top: 40px;
}
.score-content-box .score-list{
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.score-content-box .score-box .video-time-text{
  color: #969696;
  margin-right: 20px;
}
.score-content-box .pay-btn{
  color: cornflowerblue;
  padding-left: 20px;
  font-size: 14px;
}
.score-content-box .pay-btn:hover{
  color: blue;
}



.score-content-box .score-box .title{
  margin-bottom: 20px;
}

.score-content-box .score-box .el-row {
  margin-bottom: 20px;
}

.score-content-box .score-box .el-row:last-child {
  margin-bottom: 0;
}

.score-content-box .score-box .el-col {
  border-radius: 4px;
}

.score-content-box .score-box .grid-content {
  border-radius: 4px;
  min-height: 50px;
  line-height: 50px;
  padding-left: 20px;
}
.score-content-box .score-box .bg{
  background: #fdf0e9;
}

/* 原来的样式 */
.personal-series-wrapper {
  width: 100%;
  overflow: hidden;
  position: relative;
}

.personal-series-container {
  width: 1920px;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform-origin: top left;
}
.personal-series {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  flex: 1;
}
.el-carousel {
  width: 1080px;
}
.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
  text-align: center;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

/***************************** 页脚 *************************/
.home-footer {
  height: 685px;
  width: 100vw;
  background: url(@/assets/images/home-footer.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 300px;
  box-sizing: border-box;
}
</style>
